import {useState} from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bd-Sign-HRM.jpg";
import bntLogo from "assets/images/Bnt_logo.png";
import properties from "constants/ApplicationConstants";
import {POST} from "APIclient";

import {Snackbar, Alert, Button, TextField} from "@mui/material";

function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  const handleForgotPassword = async e => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");
    setIsError(false);

    try {
      const req = JSON.stringify({username});
      const url = "api/forgot-password";
      const response = await POST(url, req);
      const data = response.data ? response.data : response;
      setMessage(
        "Password reset successful. Your new password has been sent to your company email address."
      );
      setOpenSnackbar(true);
      setIsError(false);
      setUsername("");
    } catch (error) {
      console.error("Error resetting password:", error);
      setMessage(error.response?.data?.message || "An error occurred during password reset.");
      setIsError(true);
      setOpenSnackbar(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          sx={{backgroundColor: "rgba(0, 123, 255, 0.45)"}}
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={2}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="500" color="white" mt={1}>
            Forgot Password
          </MDTypography>
          <Grid container spacing={0} justifyContent="center" sx={{mt: 1}}>
            <Grid
              item
              xs={12}
              sx={{display: "flex", justifyContent: "center", alignItems: "center"}}
            >
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <img src={bntLogo} alt="BNT_SOFT" style={{width: "70px"}} />
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleForgotPassword}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                label="Username"
                fullWidth
                disabled={isLoading}
              />
            </MDBox>
            {/* {message && (
              <MDBox mb={2}>
                <MDTypography
                  variant="button"
                  color={isError ? "error" : "success"}
                  sx={{wordWrap: "break-word"}}
                >
                  {message}
                </MDTypography>
              </MDBox>
            )} */}
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                type="submit"
                sx={{background: properties.colors.bgcolorbluethem}}
                disabled={!username || isLoading}
              >
                {isLoading ? "Resetting..." : "Reset Password"}
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Back to{" "}
                <MDTypography
                  component={MuiLink}
                  href="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign In
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{vertical: "top", horizontal: "center"}}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={isError ? "error" : "success"}
          variant="filled"
          sx={{width: "100%", color: "#fff"}}
        >
          {message}
        </Alert>
      </Snackbar>
    </BasicLayout>
  );
}

export default ForgotPassword;
